import * as React from 'react';
import { Money as MoneyType } from '../../types';
import ImagesSlider from './ImagesSlider/ImagesSlider';
import Button from '../../Button/Button';
import Money from '../../Money';
import { useTheme } from '../../theme';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { NASProductCategory } from '@websky/graphql';
import { SafeHtml } from '@shared/ui';

interface Props {
	name: string;
	terminalName?: string;
	location: string;
	options: string[];
	description?: string;
	price: MoneyType;
	images: string[];
	isSelected?: boolean;
	onSelect?: () => void;

	category?: NASProductCategory;
	modifyAvailable?: boolean;
}

const EveryPortCard: React.FC<Props> = props => {
	const { t } = useTranslation('ServiceAggregation');
	const theme = useTheme('EveryPortCard').EveryPortCard;

	return (
		<div className={theme.container}>
			{!!props.images.length && (
				<div className={theme.images}>
					<ImagesSlider images={props.images} />
				</div>
			)}

			{!props.images.length && (
				<div
					className={cn(theme.images, theme.placeholder, {
						[theme.placeholder_lounge]: props.category === NASProductCategory.lounge,
						[theme.placeholder_vip]: props.category === NASProductCategory.vip,
						[theme.placeholder_meet]: props.category === NASProductCategory.meet_and_greet,
						[theme.placeholder_fasttrack]: props.category === NASProductCategory.fast_track
					})}
				/>
			)}

			<div className={theme.content}>
				<div className={theme.header}>{props.name}</div>

				<div className={theme.location}>
					{!!props.terminalName && (
						<div>
							{t('Terminal')} — {props.terminalName}
						</div>
					)}

					<div>{t(props.location)}</div>
				</div>

				{(!!props.description || !!props.options.length) && (
					<div className={theme.description}>
						{props.description && (
							<SafeHtml tag="div" className={theme.description__inner} html={props.description} />
						)}

						{!!props.options.length && (
							<ul className={theme.options}>
								{props.options.map((option, key) => {
									return <li key={key}>{t(option)}</li>;
								})}
							</ul>
						)}
					</div>
				)}

				{props.onSelect && (
					<div className={theme.buttons}>
						<div className={theme.price__wrapper}>
							<Button
								onClick={props.onSelect}
								className={cn(theme.button, {
									[theme.button_selected]: props.isSelected,
									[theme.button_priceFrom]: !props.isSelected
								})}
							>
								{props.isSelected ? (
									t('Change')
								) : (
									<>
										{t('from')}&nbsp;
										<Money money={props.price} moneyClassName={theme.price} />
									</>
								)}
							</Button>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default EveryPortCard;
